import { Col, Layout, Row, Spin, Table, Tag } from 'antd';
import axios from 'axios';
import 'moment-timezone';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import { GatewayColor, GatewayName } from '../../config/gateway';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';

const { Content } = Layout;

Moment.globalLocal = false;

class DeliveryLogs extends Component {
  state = {
    currentPage: 1,
    currentSearch: '',
    dataSource: [],
    loading: false,
    totalRows: 0,
  };

  columns = [
    {
      align: 'center',
      dataIndex: 'created',
      render: (created) => {
        if (!created) return '-';

        return (
          <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">
            {created}
          </Moment>
        );
      },
      title: 'Date / Time',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'member_id',
      render: (_, record) => {
        return record.member_detail ? record.member_detail.email || '-' : '-';
      },
      title: 'Email',
      width: '150px',
    },
    {
      align: 'center',
      dataIndex: 'phone',
      render: (phone, record) => {
        return (
          <span>
            <span>{phone}</span>
            <br />
            <Tag color="brown">{record.receiver_country || '-'}</Tag>
          </span>
        );
      },
      title: 'Phone No.',
      width: '150px',
    },
    {
      dataIndex: 'msg',
      render: (msg, record) => {
        return (
          <div style={{ maxWidth: '400px', overflowWrap: 'break-word' }}>
            <span>{msg}</span>
            <br />
            <Tag color="orange">Sender: {record.sender_name || '-'}</Tag>
            <Tag color="red" style={{ marginBottom: '8px' }}>
              Total SMS: {record.total_sms || '-'}
            </Tag>
            <br />
            <Tag color="blue">Message ID: {record.message_id || '-'}</Tag>
          </div>
        );
      },
      title: 'Message',
      width: '400px',
    },
    {
      align: 'center',
      dataIndex: 'status',
      render: (status) => {
        let color = '';
        let keyName = '-';

        if (status) {
          switch (status) {
            case 'S':
              color = 'green';
              keyName = 'Sucess';
              break;
            case 'F':
              color = 'red';
              keyName = 'Failed';
              break;
            case 'E':
              color = 'blue';
              keyName = 'Expired';
              break;
            case 'I':
              color = 'orange';
              keyName = 'Inprocess';
              break;
            case 'B':
              color = '#524b50';
              keyName = 'Blacklist';
              break;
            default:
          }
        }

        return <Tag color={color}>{keyName}</Tag>;
      },
      title: 'Status',
      width: '100px',
    },
    {
      dataIndex: 'gateway_id',
      render: (_, record) => {
        const gateway = record.gateway_detail || undefined;

        return (
          <span>
            <Tag color={GatewayColor(gateway.key_name)} style={{ marginBottom: '8px' }}>
              {GatewayName(gateway.key_name)}
            </Tag>
            <span>{record.gateway_msg_id || '-'}</span>
            <br />
            <Tag style={{ marginBottom: '8px' }}>{record.gateway_dn_response || '-'}</Tag>
            <br />
            <Tag color="cyan">Client rate: {record.client_rate || '-'}</Tag>
            <Tag color="green">Market rate: {record.market_rate || '-'}</Tag>
          </span>
        );
      },
      title: 'Gateway',
    },
  ];
  columnsMobile = [];
  limit = 10;

  componentWillMount() {
    this.props.fetchMenuAction('sms-logs', 'outbound');
  }

  changePage = async (page) => {
    this.setState({
      currentPage: page,
      loading: true,
    });

    await this.getDataList(page, this.state.currentSearch);

    this.setState({ loading: false });
  };

  getDataList = async (page = 1, search = '') => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.DELIVERY_LOGS_API}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        page,
        limit: this.limit,
        search,
      },
      url,
    };

    try {
      resp = await axios(opt);

      if (!resp.data) throw new Error("Response key 'data' is undefined.");
    } catch (e) {
      console.error(e);
      this.initialState();
      return;
    }

    this.setState({
      currentPage: resp.data.page || 1,
      dataSource: resp.data.data || [],
      loading: false,
      totalRows: resp.data.total_rows || 0,
    });
  };

  mySearch = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err) return;

      this.setState({
        currentPage: 1,
        currentSearch: values.searchTxt,
        loading: true,
      });

      await this.getDataList(1, values.searchTxt);

      this.setState({ loading: false });
    });
  };

  resetSearch = async () => {
    this.setState({
      currentPage: 1,
      currentSearch: '',
      dataSource: [],
      totalRows: 0,
    });
  };

  render() {
    let propsTable = {
      bordered: true,
      className: 'my-table',
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: 'id',
      pagination: {
        pageSize: this.limit,
        total: this.state.totalRows,
        current: this.state.currentPage,
        onChange: this.changePage,
        size: 'small',
      },
      size: 'small',
      scroll: {
        x: 1200,
      },
    };

    return (
      <Layout className="my-layout">
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>Delivery Log</h2>
            <p className="header-desc">บันทึกรายการ Outbound SMS</p>
            <Row className="utility-bar">
              <Col span={24}>
                <SearchForm
                  fn={this.mySearch}
                  fnReset={this.resetSearch}
                  placeholder="Email, Message ID, Phone No."
                  width="300px"
                />
              </Col>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.mySearch} fnReset={this.resetSearch} />
            </Row>
            <Table {...propsTable} />
          </Content>
        </Spin>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(DeliveryLogs);



// WEBPACK FOOTER //
// ./src/containers/DeliveryLogs/index.js